import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useWebSocket } from "../providers/WebSocketProvider";

export function LogoutPage() {
  const navigate = useNavigate();
  const { setToken } = useWebSocket();

  useEffect(() => {
    // Remove user-related data from localStorage
    //localStorage.removeItem("token"); set in WebSocketProvider
    setToken(null);
    localStorage.removeItem("userName");
    // Redirect to the login page
    navigate("/");
  }, [navigate, setToken]);

  return <div>Logging out...</div>;
}

export default LogoutPage;
